import { Component } from '@angular/core';
import { AdminPageHeaderComponent } from '../../../shared/admin';

@Component({
  selector: 'app-tenant-settings-page',
  standalone: true,
  imports: [AdminPageHeaderComponent],
  template: `
    <section>
      <app-admin-page-header>
        <p description class="cg-form-help">Franchise settings coming soon.</p>
      </app-admin-page-header>
    </section>
  `,
})
export class TenantSettingsPageComponent {}
